import { EnvironmentProviders } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { reportsStoreFeatureName } from './consts';
import { ReportsMetricsEffects } from './metrics/metrics.effects';
import { ReportsMetricsNamespace, ReportsMetricsReducer } from './metrics/metrics.store';

const reportsState = provideState(reportsStoreFeatureName, {
  [ReportsMetricsNamespace]: ReportsMetricsReducer,
});

const reportsEffects = provideEffects([ReportsMetricsEffects]);

export const coreReportsProviders: EnvironmentProviders[] = [reportsState, reportsEffects];
